import ReactDOM from 'react-dom'
// Axios
import {QueryClient, QueryClientProvider} from 'react-query'

// Apps
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'

import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/style.react.scss'
import AppRoutes from './app/routing/AppRoutes'
import {store} from './app/Redux/store'
import '/node_modules/flag-icons/css/flag-icons.min.css'

import {Provider} from 'react-redux'
import {PersistGate} from 'redux-persist/integration/react'
import {persistStore} from 'redux-persist'
import axios from 'axios'
import {toast} from 'react-toastify'
import {stopLoading} from './app/Redux/FrontEnd/Loading/LoadingSlice'
import storage from 'redux-persist/lib/storage'

import HelperMessagePopup from './app/Components/HelperMessagePopup'
import {GoogleReCaptcha, GoogleReCaptchaProvider} from 'react-google-recaptcha-v3'
import {PublicClientApplication} from '@azure/msal-browser'
import {msalConfig} from './authConfig'

const {dispatch} = store

axios.interceptors.response.use(
  (res: any) => {
    if (res.data.status === false) {
      res.data.message !== 'Token expired' && toast.error(res.data.message)
    }
    if (res.data.status === true && res.config.method.toLowerCase() !== 'get') {
      // toast.success(res.data.message)
    }

    return res
  },
  (error: any) => {
    const message = error.response
    dispatch(stopLoading())
    if (message?.status === 401) {
      localStorage.clear()
      storage.removeItem('persist:root')
      window?.location?.replace(window?.location?.origin + '/auth')
    } else if (message?.status === 403) {
      console.error(
        `${message?.data?.message || 'unauthorize'} ${
          message?.config?.url ? 'for endpoint ' + message?.config?.url : ''
        }`
      )
    } else if (message?.status <= 500) {
      toast.error(message.data.message)
    } else {
      toast.error('Something went wrong')
    }

    if (!error.response) {
      return Promise.reject(error)
    }

    return error.response
  }
)

const queryClient = new QueryClient()
let persistor: any = persistStore(store)

export const msalInstance = new PublicClientApplication(msalConfig)

msalInstance.initialize().then(() => {
  ReactDOM.render(
    <QueryClientProvider client={queryClient}>
      <MetronicI18nProvider>
        <Provider store={store}>
          <PersistGate persistor={persistor} loading={true}>
            <HelperMessagePopup />
            <GoogleReCaptchaProvider reCaptchaKey={'6Ld4RRUpAAAAABv3eQlB9gXl6WAI3ocx8bWCdTBN'}>
              <GoogleReCaptcha onVerify={(e) => {}} />
              <AppRoutes pca={msalInstance} />
            </GoogleReCaptchaProvider>
          </PersistGate>
        </Provider>
      </MetronicI18nProvider>
    </QueryClientProvider>,
    document.getElementById('root')
  )
})
